import { Button } from '@shopify/polaris';
import { ChevronRightIcon } from '@shopify/polaris-icons';

const CustomerAuthButton = ({ children = 'Login with Shopify', voucherCode = '', uuid = '', disabled }) => {
    const handleCustomerLogin = () => {
        const shopifyAuthUrl = new URL(`https://shopify.com/authentication/${import.meta.env.VITE_SHOPIFY_SHOP_ID}/oauth/authorize`);

        const state = voucherCode ? `method=attachVoucher&voucher=${voucherCode}&uuid=${uuid}` : '';

        shopifyAuthUrl.searchParams.append('client_id', import.meta.env.VITE_SHOPIFY_CLIENT_ID);
        shopifyAuthUrl.searchParams.append('redirect_uri', `${import.meta.env.VITE_API_URL}/auth/customer/callback/`);
        shopifyAuthUrl.searchParams.append('response_type', 'code');
        shopifyAuthUrl.searchParams.append('scope', 'openid email customer-account-api:full');
        shopifyAuthUrl.searchParams.append('state', state);
        window.location.href = shopifyAuthUrl.toString();
    };

    return (
        <Button disabled={disabled} onClick={handleCustomerLogin} variant="primary" size="large" icon={ChevronRightIcon}>
            {children}
        </Button>
    );
};

export default CustomerAuthButton;
